import { render, staticRenderFns } from "./AwardDefault.vue?vue&type=template&id=0bc58c29&scoped=true&"
import script from "./AwardDefault.vue?vue&type=script&lang=js&"
export * from "./AwardDefault.vue?vue&type=script&lang=js&"
import style0 from "./AwardDefault.vue?vue&type=style&index=0&id=0bc58c29&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc58c29",
  null
  
)

export default component.exports